module.exports = __webpack_public_path__ + "safari-pinned-tab.c54acb0b.svg";